export const formatNumber = (number, decimals = 0) => {
    return Number(number).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

